import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation CreateChannel($model: ChannelInput!) {
  createChannel(channel: $model) {
    id
    name
    type
    priority
    identifier
    group {
      id
      name
      description
    }
    teams {
      id
      name
    }
    allTeamsOn
    requestTypePriorities {
      id
      weight
    }
    config
  }
}`;

export function parseChannel(channel) {
  const config = JSON.parse(channel.config);
  return {
    ...channel,
    fields: Object.keys(config).map((name) => ({
      name,
      value: config[name],
    })),
  };
}

function createChannel(fields, model) {
  const config = {};
  fields.forEach((item) => {
    config[item.name] = item.value;
  });
  return apollo.client.mutate({
    mutation,
    variables: {
      model: {
        ...model,
        config: JSON.stringify(config),
      },
    },
  }).then((res) => parseChannel(res.data.createChannel));
}

export default createChannel;
